'use strict';
import React, { PureComponent } from 'react';

class DatosComentarios extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.initializeTooltips();
    }

    componentDidUpdate() {
        this.initializeTooltips();
    }

    initializeTooltips() {
        $('[data-toggle="tooltip"]').tooltip({
            placement: 'bottom'
        });
    }

    render() {
        let { registro, estaDesplegado } = this.props;

        let mostrarTooltip = false;
        let comentarioTruncado = null;
        let maxLength = 1055;

        if (registro && registro.Comentarios) {
            comentarioTruncado = registro.Comentarios.length > maxLength ? registro.Comentarios.substring(0, maxLength - 3) + "..." : registro.Comentarios;
            mostrarTooltip = registro.Comentarios.length > maxLength;
        }

        return (
            <div className={"AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDetalleSuperior AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorAuditoriaReproceso slider-tarjetas" + (estaDesplegado ? "" : " closed AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorAuditoriaReproceso--Inactivo")}>
                <div className="AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorComentarios"
                     data-toggle={mostrarTooltip ? "tooltip" : undefined}
                     title={mostrarTooltip ? registro.Comentarios : undefined}
                     data-placement="bottom">
                    {comentarioTruncado}
                </div>
            </div>
        );
    }
}

export default DatosComentarios;
